// extracted by mini-css-extract-plugin
module.exports = {"VesselsMenu":"styles_VesselsMenu__339RU"};